import { BaseBus } from "./BaseBus";
import { OrderDetailsBus } from "./OrderDetailsBus";
import { CommonFunctions } from "../static/common-functions";
import { GeographyInfoBus } from "./GeographyInfoBus";
import { v_SupplierLocationBus } from "./v_SupplierLocation";
import { CommonValues } from "../static/CommonValues";
import { DateFunctions } from "../static/date-functions";

export class OrderBus extends BaseBus
{
    CID(): any {
        return this.orderId;
    }
    constructor(data: OrderBus) {
        super(data);
    }
    initialize(data: OrderBus) {
        super.initialize(data);
        try {
            this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
            this.dateEntered = CommonFunctions.getDate(data.dateEntered);
            this.dateRequested = CommonFunctions.getDate(data.dateRequested);
            this.dateExpected = CommonFunctions.getDate(data.dateExpected);
            this.approvedDate = CommonFunctions.getDate(data.approvedDate);
            this.returnDt = CommonFunctions.getDate(data.returnDt);
            this.approvedDt = CommonFunctions.getDate(data.approvedDt);
        }
        catch {

        }

    }
    setFromForm(data: OrderBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        if (this.hasId) {
            this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
        this.orderStatusId = CommonValues.Order_Pending;
        this.dateEntered = date;
        this.buyerPersonId = personId;
        this.dateExpected = new Date();
        this.dateExpected.setDate(date.getDate() + 1);
        this.insertDt = date;
        this.updateDt = date;
        this.insertUserId = userId;
        this.updateUserId = userId;
        this.companyId = companyId;
    }
    setBeforeSave() {
        let dateEnt: Date = this.dateEntered;
        this.dateEntered = DateFunctions.getDateWithUTCOffset(this.dateEntered);
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
        if (DateFunctions.isValidDate(this.dateRequested)) {
            this.dateRequested = DateFunctions.getDateWithUTCOffset(this.dateRequested);
        }
        if (DateFunctions.isValidDate(this.dateExpected)) {
            this.dateExpected = DateFunctions.getDateWithUTCOffset(this.dateExpected);
        }

        if (DateFunctions.isValidDate(this.approvedDate)) {
            this.approvedDate = DateFunctions.getDateTimeWithUTCOffset(this.approvedDate);
        }
        if (DateFunctions.isValidDate(this.returnDt)) {
            this.returnDt = DateFunctions.getDateTimeWithUTCOffset(this.returnDt);
        }
        if (DateFunctions.isValidDate(this.approvedDt)) {
            this.approvedDt = DateFunctions.getDateTimeWithUTCOffset(this.approvedDt);
        }

    }
    orderId: any;
    companyId: any;
    supplierId: any;
    supplierLocationId: any;
    customerId: any;
    locationId: any;
    buyerPersonId: any;
    shippingGeographyId: any;
    shippingMethodId: any;
    isOrderPlaced: boolean;
    isOrderBilled: boolean;
    isOrderComplete: boolean;
    orderNumber: string;
    dateEntered: Date;
    dateRequested: Date;
    dateExpected: Date;
    notes: string;
    insertUserId: any;
    insertDt: Date;
    updateUserId: any;
    updateDt: Date;
    termId: any;
    ccaccountId: any;
    isLocked: boolean;
    approverUserId: any;
    approvedDate: Date;
    employeeOrderPersonId: any;
    empExpenseValidated: boolean;
    returnTrackNbr: string;
    returnVendTrackNbr: string;
    returnUserId: any;
    returnDt: Date;
    isenbr: string;
    refNbr: string;
    requestedById: any;
    orderStatusId: any;
    blanketAmount: number;
    projMgrPersonId: any;
    chgOrdBlanketAmount: number;
    approvedUserId: any;
    approvedDt: Date;
    isSub: boolean;
    markUp: number;
    shippingGeographyInfo: GeographyInfoBus;
    supplierLocation: v_SupplierLocationBus;
    orderDetails: OrderDetailsBus[];
    isConstruction: boolean;
}
